import { useState, useCallback } from "react";

export function useCollectionSharing() {
  // Shared collections
  const [sharedCollections, setSharedCollections] = useState([]);
  const [sharedCollectionsGames, setSharedCollectionsGames] = useState({});

  // Collection name editing
  const [collectionName, setCollectionName] = useState("");
  const [isEditingCollectionName, setIsEditingCollectionName] = useState(false);

  // User search for sharing
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const [userSearchResults, setUserSearchResults] = useState([]);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sharedUsersList, setSharedUsersList] = useState([]);

  // Get tab configuration for collections
  const getTabCollections = useCallback(() => {
    const tabs = [{ id: 'my-collection', name: 'My Library', type: 'own' }];

    sharedCollections.forEach(collection => {
      tabs.push({
        id: `shared-${collection.id}`,
        name: collection.name,
        type: 'shared',
        shareUrl: collection.share_url,
        ownerUsername: collection.owner_username,
        collectionData: collection
      });
    });

    return tabs;
  }, [sharedCollections]);

  const selectUser = useCallback((user) => {
    setSelectedUsers(prev => {
      if (prev.find(u => u.id === user.id)) {
        return prev;
      }
      return [...prev, user];
    });
    setUserSearchQuery("");
    setShowUserDropdown(false);
  }, []);

  const removeSelectedUser = useCallback((userId) => {
    setSelectedUsers(prev => prev.filter(u => u.id !== userId));
  }, []);

  const resetSharingState = useCallback(() => {
    setSelectedUsers([]);
    setUserSearchQuery("");
    setShowUserDropdown(false);
  }, []);

  return {
    // Shared collections
    sharedCollections,
    setSharedCollections,
    sharedCollectionsGames,
    setSharedCollectionsGames,
    getTabCollections,
    // Collection name
    collectionName,
    setCollectionName,
    isEditingCollectionName,
    setIsEditingCollectionName,
    // User search
    userSearchQuery,
    setUserSearchQuery,
    userSearchResults,
    setUserSearchResults,
    showUserDropdown,
    setShowUserDropdown,
    selectedUsers,
    setSelectedUsers,
    selectUser,
    removeSelectedUser,
    sharedUsersList,
    setSharedUsersList,
    resetSharingState
  };
}
